<template>
  <!-- 新建配载 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button class="glo_btnItems glo_bgcMainColor" @click="clickStowage">预览已配载</el-button>
      </div>
      <queryBtns :MoreConditions="MoreConditions" @clerBtns="clerBtns" @queryBtn_ok="queryBtn_ok" @moreParam="moreParam"></queryBtns>
    </div>
    <!-- 查询条件 -->
    <div ref="queryForm">
      <el-form :model="queryData" :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'" label-position="left">
        <!-- 时间组件 -->
        <el-form-item class="queryItemsTimes">
          <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time"></multitime>
        </el-form-item>
        <el-form-item class="queryItems" label="运单号:">
          <el-input placeholder="请输入" clearable v-model="queryData.waybillNumber"></el-input>
        </el-form-item>
        <el-form-item class="queryItems" label="运输计划:">
          <el-select filterable clearable v-model="queryData.transportPlan" placeholder="请选择">
            <el-option v-for="(item, index) in transport_planList" :key="index" :label="item.showName" :value="item.statusVal"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="queryItems" label="客户名称:">
          <el-select clearable filterable remote :remote-method="getCustomerList" v-model="queryData.customerName" placeholder="请选择" @change="changeCustomer">
            <el-option v-for="(item, index) in CustomerLists" :key="index" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="queryItems" label="外发承运商:">
          <el-select filterable clearable v-model="queryData.carrierId" placeholder="请输入" remote :remote-method="getCarrierList" @change="changeCarrier">
            <el-option v-for="(item, index) in CarrierLists" :key="index" :label="item.carrierName" :value="item.carrierId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="queryItems" label="装货地址:">
          <el-input placeholder="请输入" clearable v-model="queryData.taskStartAllAddress"></el-input>
        </el-form-item>
        <el-form-item class="queryItems" label="卸货地址:">
          <el-input placeholder="请输入" clearable v-model="queryData.taskEndAllAddress"></el-input>
        </el-form-item>
        <!-- <el-form-item class="queryItems queryItemsAllQuery" label="全字段查询:">
          <div class="AllQueryItems">
            <el-select class="AllQuerySelect" filterable clearable v-model="queryData.fieldName" placeholder="请选择" @change="changeField">
              <el-option v-for="(item, index) in myTableHeardAll" :key="index" :label="item.name" :value="item.field"></el-option>
            </el-select>
            <el-select v-if="isList" class="AllQuerySelect" filterable clearable v-model="queryData.fieldVal" placeholder="请选择">
              <el-option v-for="(item, index) in downList" :key="index" :label="item.showName" :value="item.statusVal"></el-option>
            </el-select>
            <el-input v-else class="AllQueryInput" clearable v-model="queryData.fieldVal" placeholder="请输入" @keyup.enter.native="queryBtn_ok"></el-input>
          </div>
        </el-form-item>-->
      </el-form>
    </div>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table :height="tableHeigth" header-align="center" ref="mytable" @row-click="rowclick" :data="tableData" border stripe :highlight-current-row="true" @selection-change="handleSelectionChange">
        <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
        <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
        <el-table-column align="center" type="dispatchNumber" label="发车批次号" width="180">
          <template slot-scope="scope">
            <el-input @click.stop.native="()=>{}" placeholder="请输入" clearable v-model="scope.row.dispatchNumber"></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" type="sort" label="顺序" width="120">
          <template slot-scope="scope">
            <el-input @click.stop.native="()=>{}" placeholder="请输入" clearable v-model="scope.row.sort"></el-input>
          </template>
        </el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            v-if="item.field == 'huoWu' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div class="linkTabel" v-if="hasPermiss('admin:task:getWaybillAddrItems')" @click.stop="getGoodsNameDetails(scope.row)">货物明细</div>
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="item.field == 'chargebackStatus' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.chargebackStatus">{{scope.row.chargebackStatus =='wei_shen_qing:chargeback_status'?'否':'是'}}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="item.field == 'loadAddrArea' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <span>{{scope.row.loadAddrProvinceName}}{{scope.row.loadAddrCityName}}{{scope.row.loadAddrArea}}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="item.field == 'unloadAreaName' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <span>{{scope.row.unloadProvinceName}}{{scope.row.unloadCityName}}{{scope.row.unloadAreaName}}</span>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          ></el-table-column>
        </template>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></paging>

    <!-- 弹窗 查看货物明细 -->
    <myDialog :diaWidth="diaWidth" :dialogTitle="dialogTitle" :isShowDialog="isShowDialog" @handleCloseDia="handleCloseDia3" @diaCancelBtn="handleCloseDia3" @diaConfirmBtn="diaConfirmBtn3()">
      <div class="glo_Table" v-if="isShowDialog">
        <el-table header-align="center" :data="goodsNameData" border stripe>
          <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
          <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
          <template v-for="(item, index) in goodsTableHeard">
            <el-table-column
              :key="index"
              :label="item.name"
              :prop="item.field"
              align="center"
              sortable
              :show-overflow-tooltip="true"
              :min-width="item.width"
              :data-isTotal="item.isTotal"
              v-if="item && item.isShow"
            ></el-table-column>
          </template>
        </el-table>
      </div>
    </myDialog>
  </div>
</template>
<script>
import paging from "@/components/pagings.vue"; //分页组件
import multitime from "@/components/multiTime.vue";
import myDialog from "@/components/Dialog.vue";
import queryBtns from "@/components/queryBtns.vue";

export default {
  inject: ["reload"],
  components: {
    paging,
    multitime,
    myDialog,
    queryBtns,
  },
  data() {
    return {
      //  -----  查询  ------
      queryData: {
        carrierId: "",
        customerName: "",
        endCreateTime: "",
        endTaskCreateTime: "",
        fieldName: "",
        fieldVal: "",
        startCreateTime: "",
        startTaskCreateTime: "",
        taskEndAllAddress: "",
        taskStartAllAddress: "",
        transportPlan: "",
        waybillNumber: "",
      }, //  表单查询数据
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "任务创建日期",
        },
        {
          value: "1",
          label: "运单创建日期",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",

      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件

      //      -------  表格  ----------
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: "75vh", //  表格高度
      selectTableData: [], //  表格选中的数据

      // 默认表头
      tabelHeadeTitle: [
        {
          name: "计划任务编号",
          field: "number",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "运单号",
          field: "waybillNumber",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        // {
        //   name: "指令单号",
        //   field: "outgoingNumber",
        //   width: "160",
        //   sort: 3,
        //   isShow: true, //是否展示
        //   isTotal: false, //是否开启合计
        //   isSort: false, //表格设置里面是否可以排序
        // },
        {
          name: "提货单号",
          field: "takeAddrNumber",
          width: "200",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "运输类型",
          field: "transportTypeShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "运输计划",
          field: "transportPlanShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "状态",
          field: "taskStatusShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "计划装货区域",
          field: "loadAddrArea",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "计划卸货区域",
          field: "unloadAreaName",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "计划装货地址",
          field: "taskStartAllAddress",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "计划卸货地址",
          field: "taskEndAllAddress",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "入仓仓库",
          field: "intoStorageName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "入仓仓库",
          field: "intoStorageName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "外发承运商",
          field: "outgoingCarrierName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "外发承运商网点",
          field: "outgoingDeptName",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "提货时间",
          field: "takeTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "交货日期",
          field: "deliveryTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "货物",
          field: "huoWu",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "货物名称",
          field: "goodsName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "总件数",
          field: "packageCout",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "总毛重",
          field: "grossWeight",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "总体积",
          field: "volume",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "客户单号",
          field: "customerOrderNumber",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "客户名称",
          field: "customerName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "客户编号",
          field: "customerNumber",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "创建人",
          field: "createUserName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "创建时间",
          field: "createTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "发车批次号",
          field: "dispatchNumber",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "车牌号",
          field: "carNumber",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "挂车号码",
          field: "trailerNumber",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "司机",
          field: "driverName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "押运员",
          field: "supercargoName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "发车合同号",
          field: "dispatchContractNumber",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "装货时间",
          field: "loadTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "装货操作人",
          field: "loadUserName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "卸货时间",
          field: "unloadTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "卸货操作人",
          field: "unloadUserName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "是否退单",
          field: "chargebackStatus",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "退单状态",
          field: "chargebackStatusShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "退单原因",
          field: "chargebackReason",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "是否回仓",
          field: "returnCangStatusShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "回仓原因",
          field: "returnCangReason",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "回仓仓库",
          field: "returnCangStorageName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
      ],
      myTableHeard: [], //  我的表头

      tableData: [], //  表格数据

      isShowDialog: false,
      dialogTitle: "货物信息",
      diaWidth: "80%",
      dialogForm: {
        // 弹窗表单数据
        aaa: "",
        bbb: "",
        ccc: "",
      },
      // ==== 弹窗组件属性 end ====

      transport_planList: [], //运输计划
      CustomerLists: [], //客户列表
      CarrierLists: [], //承运商列表

      myTableHeardAll: [],
      delArray: [],
      downList: [], //承运商列表
      isList: false, //全字段查询选择的是否是下拉列表
      goodsNameData: [],
      goodsTableHeard: [
        {
          name: "提货单号",
          field: "takeAddrNumber",
          width: "200",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货省份",
          field: "provinceName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货城市",
          field: "cityName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货区县",
          field: "areaName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货地址",
          field: "address",
          width: "200",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "货物编号",
          field: "goodsNumber",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "货物名称",
          field: "goodsName",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "品类",
          field: "itemCategoryName",
          width: "100",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "包装",
          field: "packageName",
          width: "100",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "件数",
          field: "packageCout",
          width: "80",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "毛重",
          field: "grossWeight",
          width: "80",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "净重",
          field: "netWeight",
          width: "100",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "体积重量",
          field: "volumeWeight",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "计费取值",
          field: "billingWeight",
          width: "130",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "体积/m³",
          field: "volume",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "规格",
          field: "specs",
          width: "100",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
    };
  },
  updated() {},
  created() {
    this.myTableHeard = this.tabelHeadeTitle;
    this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum); //开始时间;
    this.endTime_a = this.$TOOLS.getCurrentDate(); //今天的时间;;

    // 全字段查询的数组 删除显示值
    var myTableHeardAll = JSON.parse(JSON.stringify(this.tabelHeadeTitle));
    //  状态类型数组,要单独处理
    this.delArray = [
      {
        val: "transportPlan",
        valShow: "transportPlanShow",
      },
      {
        val: "returnCangStatus",
        valShow: "returnCangStatusShow",
      },
    ];
    this.myTableHeardAll = this.$TOOLS.delMorField(
      myTableHeardAll,
      this.delArray
    );
  },
  activated() {
    // 每次进页面都会触发的写这里
    let { selectTableData, queryData, timeType, startTime_a, endTime_a } =
      this.$route.query;
    if (selectTableData) {
      this.tableData = JSON.parse(decodeURIComponent(selectTableData)) || [];
      this.pageCount = this.tableData.length || 0;
    } else {
      // this.getData();
    }
    if (queryData) {
      this.queryData = JSON.parse(decodeURIComponent(queryData));
    }
    this.timeType = timeType || "0";
    this.startTime_a =
      startTime_a || this.$TOOLS.getFlexDate(this.$COMMON.timeNum);
    this.endTime_a = endTime_a || this.$TOOLS.getCurrentDate();
    //计算获取表格高度
    this.fetTableHeight();
  },
  mounted() {
    this.getStatusValList("bill_tms_transport_task_v3.transport_plan"); //运输计划
    this.getCustomerList(); //  获取客户列表
    this.getCarrierList(); // 获取承运商列表
  },
  watch: {},
  methods: {
    clickStowage() {
      //  预览配载
      if (!this.selectTableData.length) {
        this.$message.warning("请选择需要操作的任务");
        return false;
      }
      let taskIds = this.selectTableData.map((n) => {
        return n.taskId;
      });
      let selectList = [];
      for (let i = 0; i < this.tableData.length; i++) {
        let element = this.tableData[i];
        if (taskIds.includes(element.taskId)) {
          selectList.push(element);
          if (!element.dispatchNumber || !element.sort) {
            this.$message.warning(`请输入第${i + 1}行 发车批次号或顺序`);
            return false;
          }
        }
      }
      let afterData = [];
      selectList.forEach((item) => {
        let flag = afterData.find(
          (n) => item.dispatchNumber === n.dispatchNumber
        );
        if (!flag) {
          afterData.push({
            dispatchNumber: item.dispatchNumber,
            childs: [item],
          });
        } else {
          flag.childs.push(item);
        }
      });
      this.$router.push({
        path: "/DispatchCar/TasksLoaded/PreviewStowage",
        query: {
          selectList: encodeURIComponent(JSON.stringify(afterData)),
          returnList: encodeURIComponent(JSON.stringify(this.tableData)),
          queryData: encodeURIComponent(JSON.stringify(this.queryData)),
          timeType: this.timeType,
          startTime_a: this.startTime_a,
          endTime_a: this.endTime_a,
        },
      });
    },
    // 选择字段查询
    changeField(e) {
      this.isList = false;
      this.queryData.fieldVal = "";
      this.delArray.forEach((item) => {
        if (item.val == e) {
          this.isList = true;
          if (e == "transportPlan") {
            this.downList = this.transport_planList;
          }
          if (e == "returnCangStatus") {
            this.downList = [];
          }
        }
      });
    },
    // 获取状态下拉列表
    getStatusValList(val) {
      this.$TOOLS.getStatusValList(val).then((res) => {
        // 运输计划
        if (val === "bill_tms_transport_task_v3.transport_plan") {
          this.transport_planList = res;
        }
      });
    },
    // 选择承运商
    changeCarrier(e) {
      if (!e) {
        this.getCarrierList();
      }
      this.queryBtn_ok();
    },
    // 获取承运商列表
    getCarrierList(carrierName) {
      this.$API
        .CarrierList({
          pageStart: 1,
          pageTotal: 200,
          carrierName: carrierName || "",
        })
        .then((res) => {
          this.CarrierLists = res.data.result.data || [];
        });
    },
    // 获取客户列表
    getCustomerList(name) {
      this.$API
        .wtl_getObjectUserDownList({
          key: "customer",
          name: name || "",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CustomerLists = res.data.result.data || [];
        });
    },
    // 选择或者清除客户时触发
    changeCustomer(e) {
      if (!e) {
        this.getCustomerList();
      }
      this.queryBtn_ok();
    },
    // 查看货物明细:
    getGoodsNameDetails(row) {
      this.$API.wtl_getTaskItems({ taskId: row.taskId }).then((res) => {
        this.goodsNameData = res.data.result || [];
        this.isShowDialog = true;
      });
    },
    // 时间组件 选择时间后触发
    queryBtn_time(s, e) {
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },
    // 时间组件 选择类型后触发
    timestatus(type, s, e) {
      this.timeType = type || "0";
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },

    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },

    getData() {
      let startTaskCreateTime = ""; //业务时间 开始
      let endTaskCreateTime = ""; //业务时间 结束

      let startCreateTime = ""; //创建时间 开始
      let endCreateTime = ""; //创建时间 结束
      if (this.timeType == 1) {
        // 1==创建时间
        startCreateTime = this.startTime_a
          ? this.startTime_a + " 00:00:00"
          : "";
        endCreateTime = this.endTime_a ? this.endTime_a + " 23:59:59" : "";
      } else {
        //业务时间
        startTaskCreateTime = this.startTime_a
          ? this.startTime_a + " 00:00:00"
          : "";
        endTaskCreateTime = this.endTime_a ? this.endTime_a + " 23:59:59" : "";
      }
      let param = {
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
        dispatchStatus: "wei_pei_zai:dispatch_status",
        carrierId: this.queryData.carrierId,
        customerName: this.queryData.customerName,
        endCreateTime: endCreateTime,
        endTaskCreateTime: endTaskCreateTime,
        fieldName: this.queryData.fieldName,
        fieldVal: this.queryData.fieldVal,
        startCreateTime: startCreateTime,
        startTaskCreateTime: startTaskCreateTime,
        taskEndAllAddress: this.queryData.taskEndAllAddress,
        taskStartAllAddress: this.queryData.taskStartAllAddress,
        transportPlan: this.queryData.transportPlan,
        waybillNumber: this.queryData.waybillNumber,
      };
      this.$API.wtl_getTaskList(param).then((res) => {
        if (res.data.status === "success") {
          this.tableData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.fetTableHeight();
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`);
        }
      });
    },

    queryBtn_ok() {
      //  查询按钮
      this.pageStart = 1;
      this.getData();
    },
    clerBtns() {
      //  重置按钮
      this.queryData = {
        carrierId: "",
        customerName: "",
        endCreateTime: "",
        endTaskCreateTime: "",
        fieldName: "",
        fieldVal: "",
        startCreateTime: "",
        startTaskCreateTime: "",
        taskEndAllAddress: "",
        taskStartAllAddress: "",
        transportPlan: "",
        waybillNumber: "",
      };
      this.timeType = "0";
      this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum);
      this.endTime_a = this.$TOOLS.getCurrentDate();
      this.pageStart = 1;
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore;
      if (this.isHaseMore) {
        this.MoreConditions = "收起条件";
      } else {
        this.MoreConditions = "更多条件";
      }
      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    handleSizeChange(val) {
      //  分页
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      //  分页
      this.pageStart = val;
      this.getData();
    },
    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e;
    },

    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight; // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10; //查询框
      }
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight;
        this.$refs.mytable.doLayout();
      });
    },
    handleCloseDia3() {
      this.isShowDialog = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtn3() {
      this.isShowDialog = false;
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn3() {
      this.isShowDialog = false;
    },
  },
};
</script>
<style scoped lang="less">
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }

  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerboxs {
  width: 100%;
  padding: 5px 0;
  display: flex;
  align-items: center;
}

.iconInput {
  display: flex;
  align-items: center;
}
.mainCOlorBtns {
  background-color: #f0a261;
  color: #fff;
  border: none;
}
.mainCOlorBtns :hover {
  color: #fff;
}
</style>
